import Slide from './Slide'
import SlideSubTitle from './SlideSubTitle'

Slide.SubTitle = SlideSubTitle

export default Slide
